import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faIgloo,faArrowLeft,faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { BrowserRouter, Route } from "react-router-dom";
import { withCookies } from 'react-cookie';
import Container from './Components/Container/';
import Header from './Components/Header/';
import Footer from './Components/Footer/';
import "./../node_modules/bulma/css/bulma.css";

library.add(faIgloo,faArrowLeft,faTimesCircle);

const Redirect = () => { 
  window.location.href = '/mini-sites/professionnels-de-sante/article/professionnel-de-sante '; 
  return null;
}

class App extends Component {

  constructor(props) {
      super(props);
      this.state = {
        data: null,
      }
  }

 componentDidMount() {
   fetch('https://www.ght-artois.fr/?page=annuaire_pwa.json&var_mode=recalcul#')
     .then(response => response.json())
     .then(data => this.setState({data: data }))
     .catch(error => this.setState({ error }));
  }

  render() {
    // // console.log('App this.state : ',this.state);
    // // console.log('App this.props : ',this.props);
    const userCookie = this.props.cookies.cookies.annuaire;

    return (

      <BrowserRouter>
        <div>
          <Route path="/annuaire/" component= {() =>
              !userCookie 
                ? <Redirect />
                : this.state.data ? (
                    <div>
                    <Header datas={this.state.data[0].header} />
                    <Container datas={this.state.data[0].content}/>
                    <Footer datas={this.state.data[0].footer} />
                    </div>
                  ) : (
                    <div className="App">
                      <p>Chargement</p>
                    </div>
                  )
                }
          />
        </div>
      </BrowserRouter>
    );
  }

}

export default withCookies(App);
